import { exists } from '@/api'

export interface SystemCodeArea {
  id: number
  code: string
  name: string
  shortName: string
  revision: number
}

export function SystemCodeAreaFromJSON(json: any): SystemCodeArea {
  return {
    id: exists(json, 'id') ? json.id : 0,
    code: exists(json, 'code') ? json.code : '',
    name: exists(json, 'name') ? json.name : '',
    shortName: exists(json, 'short_name') ? json.short_name : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}

export const defaultSystemCodeArea = (): SystemCodeArea => ({
  id: 0,
  code: '',
  name: '',
  shortName: '',
  revision: 1
})
